module.exports = __webpack_public_path__ + "static/media/happy-new.ad29237c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/happy-new.svg
// module id = 962
// module chunks = 0